import styled from '@emotion/styled';

/**
 * Корневой элемент иконку кнопки открытия меню.
 */
export const Root = styled.svg`
  vertical-align: top;
`;
